import { Injectable } from '@angular/core';
import { AuthGuard, AuthService } from '@auth0/auth0-angular';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { InviteApiController } from '../api-controllers/invite.api-controller';
import { OrganizationManager } from '../managers/organization.manager';
import { LoggingService } from '../../../../modules/src/lib/core/services/logging.service';
import { BillingManager } from '../managers/billing.manager';
import { InviteManager } from '../managers/invite.manager';
import { OrganizationModel } from '../../../../../../common/dist/angular/models/organization.model';

@Injectable()
export class HasOrganizationGuard implements CanActivate {
  constructor(private readonly authService: AuthService,
              private readonly authGuard: AuthGuard,
              private readonly router: Router,
              private readonly inviteApiController: InviteApiController,
              private readonly organizationManager: OrganizationManager,
              private readonly loggingService: LoggingService,
              private readonly billingManager: BillingManager,
              private readonly inviteManager: InviteManager,
  ) {
  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    return new Promise((resolve, reject) => {
      // If you are not logged-in, redirect to login
      this.authGuard.canActivate(route, state).subscribe(async isAuthenticated => {
        if (isAuthenticated === false) {
          this.loggingService.debug('[Guard:\'has-organization\'] - User is not authenticated, therefore we determine that user doesn\'t have org and redirect to /login.');
          return resolve(this.router.parseUrl('/login'));
        }

        let organization: OrganizationModel;

        if (state.url.indexOf('onboarding') !== -1) {
          organization = await this.organizationManager.refresh();
        } else {
          organization = await this.organizationManager.getCurrent();
        }

        if (organization === null) {
          // Check if you have any invites
          const invites = await this.inviteManager.getForCurrentUser();
          if (invites.length > 0) {
            this.loggingService.debug('[Guard:\'access\'] - User has pending invites, redirecting to /onboarding/invites');
            return resolve(this.router.parseUrl('/onboarding/invites'));
          }

          this.loggingService.debug('[Guard:\'has-organization\'] - User doesn\'t have any organization, redirecting to /onboarding/organization/create');
          return resolve(this.router.parseUrl('/onboarding/organization/create'));
        }

        return resolve(true);
      });
    });
  }
}
